/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allow_Orphan_WordsInputs */



/**
* | output |
* | --- |
* | "Allow Orphan Words" |
*
* @param {Allow_Orphan_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const allow_orphan_words = /** @type {((inputs?: Allow_Orphan_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allow_Orphan_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autoriser les mots orphelins")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zulassen von verwaisten Wörtern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Consenti parole orfane")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрешить использование слов-сирот")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permitir palabras huérfanas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("允许孤立词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("孤立語を許可する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनाथ शब्दों की अनुमति दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permitir palavras órfãs")
	return /** @type {LocalizedString} */ ("Allow Orphan Words")
});